import ItemBaseController from '../common/item.base.controller';
import AppConstants from '../../../config/app.constants';

class ItemEditController extends ItemBaseController {
	/*@ngInject*/
	constructor(Auth, $state, User, ItemService, Modal, $translate, $stateParams, LocationService, ServiceOrderService, $scope, DateUtil) {
		super(Auth, $state, User, ItemService, Modal, $translate, $stateParams)

		this.LocationService = LocationService;
		this.ServiceOrderService = ServiceOrderService;
		this.ItemService = ItemService;
		this.$scope = $scope;
		this.user = User;
		this.DateUtil = DateUtil;
		this.hasACL = {};
		this.defaultModel = {
			itemTypeId: null,
			barcode: null,
			itemLabel: null,
			notes: null,
			loggedInUserId: this.User.getUser().id,
			selectedBranch: [],
			errorMessage: null,
			branchId: this.User.getUser().branchId,
			loading: false,
			gettingItems: false,
			reference: null,
			expirationDate: null
		}
		this.model = angular.copy(this.defaultModel);
		this.userBranches = [];
		this.itemTypes = [];
		this.itemTypeList = [];
	}

	$onInit() {
		this.loadData();
		this.loadItemTypes('', 0);
		this.maxDate = {
			minDate: moment().add('1', 'day')
		}
	}

	loadItemTypes(searchKey, offset) {
		searchKey = searchKey || null;

		const itemTypeId = this.model.itemTypeId ? this.model.itemTypeId.Value : null;

		if (offset !== 0 && !searchKey && Math.abs(offset % 2) == 1) {
			offset = offset - 1;
		}

		this.ItemService.getItemTypes(this.model.itemTypeId, searchKey, AppConstants.defaultPageLimit, offset)
			.then((data) => {
				if (offset === 0 || offset == undefined) {
					this.itemTypes = data.results;
					this.totalRecords = data.total;
					this.itemTypeList = this.dataMapping(data.results, searchKey);
				} else {
					const records = this.dataMapping(data.results, searchKey);
					this.itemTypeList = this.itemTypeList.concat(records);
				}
			})
			.catch((err) => {
				console.log(err);
			});
	}

	dataMapping(types, searchKey) {
		let type = [];
		types.map((data) => {
			data.Key = data.id + " | " + data.label;
			data.Value = data.id;
			data.Label = data.label;

			if (!searchKey && this.model.itemTypeId) {
				if (data.id !== this.model.itemTypeId) {
					type.push(data);
				}
			} else {
				type.push(data);
			}
		});
		return type;
	}

	loadData() {
		this.model.gettingItems = true;
		this.Service.getItem(this.$stateParams.id)
		.then((data) => {
			this.defaultModel = data;
			this.itemObj = data;
			this.rawId = data.itemId;
			this.model.itemTypeId = data.itemTypeId;
			this.model.barcode = data.barcode;
			this.model.itemLabel = data.label;
			this.model.notes = data.notes;
			this.model.reference = data.reference || 'N/A';
			this.model.expirationDate = data.expirationDate ? this.DateUtil.convertToDate(data.expirationDate) : null;

			this.model.itemTypeId = {
				Key: this.itemObj.itemTypeId + ' | ' + this.itemObj.label,
				Value: this.itemObj.itemTypeId,
				Label: this.itemObj.label
			}
		})
		.catch((err) => {
			console.error(err);
		})
		.finally(() => {
			this.model.gettingItems = false;
		})
	}

	changeItemType() {
		// console.log('>>1>>>>',this.model.itemTypeId);
	}

	reset() {
		this.model = angular.copy(this.defaultModel)
		this.model.itemTypeId = {
			Key: this.itemObj.itemTypeId + ' | ' + this.itemObj.label,
			Value: this.itemObj.itemTypeId,
			Label: this.itemObj.label
		}
		this.clearErrors();
	}

	submit() {
		this.errorMessage = '';
		this.model.loading = true;

		this.Service.update(this.rawId, {
			itemId: this.itemObj.itemId,
			barcode: this.model.barcode,
			// itemTypeId: this.itemObj.itemTypeId,
			// itemTypeId: this.model.itemTypeId,
			label: this.model.itemTypeId.Label,
			itemTypeId: this.model.itemTypeId.Value,
			// label: this.model.itemLabel,
			notes: this.model.notes,
			branchId: this.model.branchId,
			reference: this.model.reference,
			expirationDate: this.model.expirationDate ? moment(this.model.expirationDate).format('YYYY-MM-DD') : null
		})
			.then(() => {
				window.history.go(-1);
			})
			.catch((err) => {
				err.data.errors.map((e) => {
					this.errorMessage += e.message;
				})
			})
			.finally(() => {
				this.model.loading = false;
			})
	}

	validateForm() {
		return !(this.model.itemTypeId && this.model.barcode);
	}

}

export default ItemEditController;


// WEBPACK FOOTER //
// ./client/app/components/item/edit/item.edit.controller.js